import { ArticleSubtitle } from "@babackapp/customer-ui/components/article";
import { DiscountedPrice } from "@babackapp/return-widget-components/components/discounted-price";
import { getPaidPriceInCents } from "@babackapp/return-widget-components/lib/paid-price.lib";
import type { OrderLineItem } from "@babackapp/return-widget-components/types";
import { parseLineItemPriceInCents } from "@babackapp/return-widget-components/utils/get-line-item-price";
import { formatVariantOptions } from "../../utils/format-variant-options";

type LineItemSubtitleProps = {
  lineItem: OrderLineItem;
  currency: string;
};

/** Variant options, then the unit price of an order line. */
export function LineItemSubtitle({ lineItem, currency }: LineItemSubtitleProps) {
  const options = formatVariantOptions(lineItem);
  const catalogCents = parseLineItemPriceInCents(lineItem.price);

  if (!options && catalogCents == null) return null;

  return (
    <ArticleSubtitle>
      {options}
      {options && catalogCents != null && " • "}
      {catalogCents != null && (
        <DiscountedPrice
          catalogCents={catalogCents}
          paidCents={getPaidPriceInCents(lineItem)}
          currency={currency}
        />
      )}
    </ArticleSubtitle>
  );
}
